export default __webpack_public_path__ + "static/media/Markforged.43365b17.png";